import { render, staticRenderFns } from "./PaginationHelper.vue?vue&type=template&id=3e8f67dc&scoped=true"
import script from "./PaginationHelper.vue?vue&type=script&lang=js"
export * from "./PaginationHelper.vue?vue&type=script&lang=js"
import style0 from "./PaginationHelper.vue?vue&type=style&index=0&id=3e8f67dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8f67dc",
  null
  
)

export default component.exports